import { ReactNode } from 'react';

import {
  FacebookIconHeader,
  InstagramIconHeader,
  TelegramIconHeader,
  TikTokIconHeader,
  TwitterIconHeader,
} from '@constants/common/icons.constants';
import {
  FACEBOOK_LINK,
  INSTAGRAM_LINK,
  TELEGRAM_LINK,
  TIKTOK_LINK,
  TWITTER_LINK,
} from '@constants/common/links.constants';

type SocialItem = {
  title: string;
  path: string;
  icon: ReactNode;
  disabled?: boolean;
};

export const SOCIAL_LINKS: SocialItem[] = [
  {
    title: 'Telegram',
    path: TELEGRAM_LINK,
    icon: TelegramIconHeader,
  },
  {
    title: 'X',
    path: TWITTER_LINK,
    icon: TwitterIconHeader,
  },
  {
    title: 'Instagram',
    path: INSTAGRAM_LINK,
    icon: InstagramIconHeader,
  },
  {
    title: 'TikTok',
    path: TIKTOK_LINK,
    icon: TikTokIconHeader,
  },
  {
    title: 'Facebook',
    path: FACEBOOK_LINK,
    icon: FacebookIconHeader,
  },
];
